<!--
 * @Description: 折线图
 * @Author: mdb
 * @Date: 2022-11-28 11:30:34
 * @LastEditTime: 2022-11-29 11:02:14
 * @LastEditors: mdb
-->
<template>
  <div ref="chartRef" :style="{ width, height }" v-if="showECharts"></div>
  <!-- <dc-layout-empty type="nothing" :style="{ width, height }" v-if="!showECharts" /> -->
  <Empty :style="{ width, height }" v-if="!showECharts" />
</template>
  
  <script setup lang="ts">
import { onBeforeMount, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { PropType, Ref } from 'vue'
import removeTrailingZeros from '@/utils/format'
import Empty from './Empty.vue'

const props = defineProps({
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '300px'
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => {
      return []
    }
  },
  isPercentageY: {
    type: Boolean as PropType<boolean>,
    default: () => {
      return false
    }
  }
})
const showECharts = ref(false)
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
watch(
  () => props.data,
  (v) => {
    initChart()
  }
)

const initChart = () => {
  showECharts.value = props.data.length > 0
  setOptions({
    grid: {
      left: '2%',
      right: '2%',
      bottom: '1%',
      // top: '8%',
      containLabel: true
    },
    legend: {
      itemWidth: 12,
      itemHeight: 2,
      left: 'right',
      icon: 'react',
      right: '50%',
      data: props.data.map((item) => item.name)
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: '#fff'
      },
      formatter: function (params) {
        return props.data[params.seriesIndex].value[params.dataIndex].tooltip
      }
    },
    xAxis: {
      type: 'category',
      data: props.data.length > 0 ? props.data[0].value.map((item) => item.name) : []
    },
    yAxis: {
      type: 'value',
      min: 0,
      splitLine: {
        show: true,
        lineStyle: {
          color: '#D8DFE4',
          type: 'dashed'
        }
      }
    },
    series: props.data.map((item) => {
      return { name: item.name, type: 'bar', barMinHeight: 1, data: item.value.map((item) => item.value) }
    })
  })
}

onBeforeMount(() => {
  initChart()
})
</script>
  <script lang="ts">
export default { name: 'BoardBarChart' }
</script>
  
  <style scoped></style>
  